import { useQueryClient } from '@tanstack/react-query';
import { getQueryBaseKey } from './getQueryKey';
export const getUseGetQueryData = (wrapperOptions) => {
    const useWrappedGetQueryData = () => {
        const queryClient = useQueryClient();
        const queryKey = getQueryBaseKey(wrapperOptions, 'query');
        const getQueryData = () => {
            return queryClient.getQueryData(queryKey);
        };
        return getQueryData;
    };
    return useWrappedGetQueryData;
};
